import {
  ConfigurationType,
  PtacUnitPickType,
  SavePtacQuotableSystemRequestType,
  SystemOptionType
} from 'data/types';
import { ptacSystemsUnitsPayload } from 'utils/ptac-systems-request';

export const PTAC_QUOTABLE_SYSTEM_URL = '/ptac-quotable-system';

export function ptacQuotableSystemBody(
  option: SystemOptionType,
  unitPicks: PtacUnitPickType[]
): SavePtacQuotableSystemRequestType {
  return {
    configurationUniqueId: option.configuration.uniqueId,
    units: unitPicks
  };
}

export function ptacUnitPicksMatchConfiguration(
  configuration: ConfigurationType,
  unitPicks: PtacUnitPickType[]
): boolean {
  const unitIds = ptacSystemsUnitsPayload(configuration).map(
    (unit) => unit.condenserUniqueId
  );
  const pickedIds = new Set(unitPicks.map((pick) => pick.condenserUniqueId));
  return (
    unitIds.length === pickedIds.size &&
    unitIds.every((unitId) => pickedIds.has(unitId))
  );
}
